import { createIcon } from "@chakra-ui/react";

export const MinusSolid = createIcon({
  displayName: "MinusSolid",
  viewBox: "0 0 24 24",
  d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24zM8.625 10.875h6.75c.623 0 1.125.502 1.125 1.125s-.502 1.125-1.125 1.125h-6.75A1.122 1.122 0 0 1 7.5 12c0-.623.502-1.125 1.125-1.125z",
  defaultProps: {
    "aria-label": "Minus symbol: A horizontal line within a circle"
  }
});

export default MinusSolid;
